import { render } from "./ui-header-user.vue?vue&type=template&id=851c9448&scoped=true"
import script from "./ui-header-user.vue?vue&type=script&lang=js"
export * from "./ui-header-user.vue?vue&type=script&lang=js"

import "./ui-header-user.vue?vue&type=style&index=0&id=851c9448&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851c9448"]])

export default __exports__